module.exports = __webpack_public_path__ + "static/media/mining-rule-cn.fa8fcf25.png";